import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import styled, { css } from 'styled-components';

export const StyledCardWrapper = styled.div`
    background: linear-gradient(156.67deg, hsla(240, 1%, 44%, 0.4) 0.07%, rgba(100, 97, 113, 0.148) 99.07%);
    border: 1.5px solid #28303f;
    border-radius: 15px;
    padding: 20px 18.5px 19px;
    transition: all 0.3s ease;
    margin-bottom: 50px;
    min-width: 172px;
    position: relative;
    z-index: 2;

    ${media.md`
        min-width: 220px;
    `}

    &:hover {
        cursor: pointer;
        transform: translateY(-10px);
    }
`;

export const StyledTypeWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 1;
    background-color: rgba(13, 12, 12, 0.5);
    height: 32px;
    width: 32px;
    border-radius: 50%;

    ${media.sm(css`
        height: 34px;
        width: 34px;
    `)}
`;

export const StyledName = styled(Typography)<{ withCopies: boolean; cardVariant: 'dark' | 'light' }>`
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.text};
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    margin-top: -2px;
    min-height: 40px;

    & > div {
        border: 1px solid ${({ theme }) => theme.colors.white};
        border-radius: 50%;
        height: 40px;
        align-items: center;
        justify-content: center;
        width: 40px;
        padding-right: 5px;
        display: flex;
        & > i {
            color: ${({ theme }) => theme.colors.white};
        }
    }

    ${media.sm`
        font-size: 20px;
        font-weight: 700;
  `};
`;

export const StyledFeatures = styled.div`
    margin-bottom: 16px;
    overflow: hidden;
    position: relative;
`;

export const StyledCountDown = styled.div`
    backdrop-filter: blur(4px);
    background: hsla(0, 0%, 100%, 0.7);
    border: 1px solid hsla(0, 0%, 100%, 0.6);
    border-radius: 100px;
    bottom: 24px;
    content: '';
    left: 50%;
    padding: 4px 17px;
    position: absolute;
    top: unset;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
`;

export const StyledRainDrop1 = styled.div`
    content: '';
    left: 18px;
    position: absolute;
    top: 22px;
`;

export const StyledRainDrop2 = styled.div`
    content: '';
    position: absolute;
    right: 18px;
    bottom: 31px;
`;

export const StyledBottom = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const StyledSubTitle = styled.div``;

export const StyledPositionName = styled.div`
    color: ${({ theme }) => theme.colors.white};

    ${media.sm`
        font-size: 14px;
        font-weight: 300;
  `};
`;

export const StyledCreatorName = styled(Typography)`
    color: ${({ theme }) => theme.colors.white};

    ${media.sm`
        font-size: 16px;
        font-weight: 700;
  `};

    &:hover {
        color: ${({ theme }) => theme.colors.blue600};
    }
`;

export const StyledPrices = styled.div<{ notOnSale: boolean; notMinted: boolean; variant: 'dark' | 'light' }>`
    ${({ notMinted, notOnSale, theme, variant }) => {
        if (notMinted) {
            return `color: ${theme.colors.pink500};`;
        }
        if (notOnSale) {
            return `color: ${theme.colors.gs200};`;
        }
        if (variant === 'light') {
            return `color: ${theme.colors.warmBlack};`;
        }
        return `color: ${theme.colors.white};`;
    }};

    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 45px;

    svg {
        width: 16px !important;
        height: 16px !important;
        flex: 0 0 16px;
        margin-right: 10px;

        ${({ notMinted, theme }) =>
            notMinted &&
            css`
                color: ${theme.colors.pink500};
            `}
    }

    ${media.sm`
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    height: 19px;
    white-space: nowrap;
  
    & > span {
      font-weight: 500;
    }
  `};

    ${media.md`
    svg {
      width: 20px !important;;
      height: 20px !important;
      flex: 0 0 20px;
    }
  `}
`;

export const StyledBottomButton = styled.div`
    margin: 10px 0;
`;
